/**
 * Created by devmaster on 7/15/2017 AD.
 */
import React, { Component } from 'react'


 class BankForm extends Component{

  constructor (props){
     super(props)
     this.state = {
        bank_name: '',
        bank: this.props.bank
     }

     this.onChangeBank = this.onChangeBank.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if(JSON.stringify(nextProps.bank) !== JSON.stringify(this.props.bank)){
      this.setState({ bank: nextProps.bank })
    }
  }

   onChangeBank(event){
     this.setState({ bank :{
         bank_name : event.target.value
       }})
   }

  render(){

     return (
       <div className="card card-accent-danger">
         <div className="card-header">
           <strong>เพิ่มธนาคาร</strong>
         </div>
           <form action="" method="post" onSubmit={ (this.props.actionType==="แก้ไข")? this.props.onBankSubmit.update :this.props.onBankSubmit.add  }>
         <div className="card-block">

             <div className="form-group">
               <label htmlFor="bank_name">ชื่อธนาคาร</label>
               <input
                      value={this.state.bank.bank_name || ''}
                      type="text"
                      className="form-control"
                      name="bank_name"
                      placeholder="กรอกชื่อธนาคาร"
                      onChange={this.onChangeBank}
               />

             </div>


         </div>
         <div className="card-footer text-right">
               <button type="reset" className="btn btn-sm btn-danger"><i className="fa fa-refresh"></i> ยกเลิก</button>
               <button type="submit" className={this.props.actionType==="แก้ไข"?  "btn btn-sm btn-warning" : "btn btn-sm btn-primary"}>
                 <i className={this.props.actionType==="แก้ไข"? "fa fa-edit": "fa fa-save"}></i> {this.props.actionType}</button>
           </div>
           </form>
       </div>
     );
  }
}
/*
BankForm.propTypes = {
    onUserSubmit: React.PropTypes.func.isRequired,

};*/
export  default BankForm;